<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="left">
            <div class="title big">{{ $t('Welcome to GamesSkins') }}</div>
            <div class="desc">
              {{ $t('Browse all CS:GO skins, knives, gloves, cases, collections, stickers, music kits, and more. The Trinity shop is the best place to buy CS:GO skins in a simple manner.') }}
            </div>
            <router-link to="products" class="button">
              <span>{{ $t('Shop Now') }}</span>
            </router-link>
          </div>
          <div class="right">
            <img src="./../assets/guns.png" class="img"/>
          </div>
        </div>
      </div>
      <div class="section features-section">
        <ul class="list">
          <li class="item">
            <div class="icon">
              <img src="./../assets/shield.svg" class="img"/>
            </div>
            <div class="title">{{ $t('100% Secure') }}</div>
            <div class="desc">{{ $t('All transactions are thoroughly monitored, so your money and skins are safe.') }}</div>
          </li>
          <li class="item">
            <div class="icon">
              <img src="./../assets/layer.svg" class="img"/>
            </div>
            <div class="title">{{ $t('Wide Choice') }}</div>
            <div class="desc">{{ $t('There are many variations of unique and high quality skins.') }}</div>
          </li>
          <li class="item">
            <div class="icon">
              <img src="./../assets/discount.svg" class="img"/>
            </div>
            <div class="title">{{ $t('Best Prices') }}</div>
            <div class="desc">{{ $t('CS isn\'t about flash grenades and headshots, it\'s about looking beautiful. Cheap, fast, safe and 24/7.') }}</div>
          </li>
        </ul>
      </div>
      <div class="section arrivals-section">
        <div class="wrapper">
          <div class="top">
            <div class="title">
              <span>{{ $t('NEW') }}</span> {{ $t('Arrivals') }}
            </div>
            <router-link to="/new-arrivals" class="link">
              <span>{{ $t('Add to') }}</span>
              <img class="img" src="./../assets/right-arrow.svg"/>
            </router-link>
          </div>
          <SlickItem v-if="$parent.newArrivals.length" :list="$parent.newArrivals" :tag="$t('Valve')" />
        </div>
      </div>
      <div class="section more-offers-section">
        <div class="wrapper">
          <div class="left img-container">
            <img class="img" src="./../assets/more-offers-img.png"/>
          </div>
          <div class="left">
            <div class="title big">{{ $t('More than 1K offers') }}</div>
            <ul class="list">
              <li class="item desc">
                {{ $t('There are many variations of skins to choose from') }}
              </li>
              <li class="item desc">
                {{ $t('Cheap CS:GO skins at a discounted price') }}
              </li>
              <li class="item desc">
                {{ $t('It is your chance to get Dragon lore and other epic items!') }}
              </li>
            </ul>
            <router-link to="products" class="button long">
              <span>{{ $t('View all offers') }}</span>
            </router-link>
          </div>
        </div>
      </div>
      <div class="section slider-section">
        <div class="slider-container" v-if="$parent.newArrivals.length">
          <slick ref="slick" :options="slickCompact" @init="handleInit" @swipe="handleSwipe" class="slider-small products">
            <div class="item" v-for="(item, index) in $parent.newArrivals" :key="index">
              <a @click="goToSliderItem(item)" :class="['item-wrapper', {'disabled': !sliderIsClickble}]">
                <div class="text">
                  <div class="desc">{{item.category}}</div>
                  <div class="title">{{item.title}}</div>
                </div>
                <div class="preview">
                  <img :src="imgDomain + item.img_url" class="img"/>
                </div>
              </a>
            </div>
          </slick>
        </div>
      </div>
      <div class="section arrivals-section recommended-section">
        <div class="wrapper">
          <div class="top">
            <div class="title">
              Recommended
            </div>
            <router-link to="/recommended" class="link">
              <span>View more</span>
              <img class="img" src="./../assets/right-arrow.svg"/>
            </router-link>
          </div>
          <SlickItem v-if="$parent.recommendedProducts.length" :list="$parent.recommendedProducts" :tag="'We Recommend'" />
        </div>
      </div>
      <div class="section daily-offer-section" v-if="dailyOffer && dailyOffer.length">
        <div class="wrapper" @click="$parent.goToProduct(dailyOffer)">
          <div class="preview" v-if="dailyOffer.img_url">
            <img :src="imgDomain + dailyOffer.img_url" class="img"/>
          </div>
          <div class="center">
            <div class="title">Daily Offer</div>
            <div class="countdown">
              <div class="column">
                <div class="num">6</div>
                <div class="desc">Days</div>
              </div>
              <div class="column">
                <div class="num">5</div>
                <div class="desc">Hours</div>
              </div>
              <div class="column">
                <div class="num">39</div>
                <div class="desc">Minutes</div>
              </div>
              <div class="column">
                <div class="num">15</div>
                <div class="desc">Seconds</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="title small">{{dailyOffer.title}}</div>
            <div class="title price">
              {{dailyOffer.price}}
              <span class="currency">{{currency}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section arrivals-section sale-section">
        <div class="wrapper">
          <div class="top">
            <div class="title">
              Sale
            </div>
            <router-link to="/sale" class="link">
              <span>View more</span>
              <img class="img" src="./../assets/right-arrow.svg"/>
            </router-link>
          </div>
          <SlickItem v-if="$parent.saleProducts.length" :list="$parent.saleProducts" :tag="'Sale'" />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Slick from 'vue-slick';
import SlickItem from '../components/SlickItem.vue';

export default {
  name: 'Home',
  props: ['addToCartChosenItem', 'currency'],
  components: {
    Slick,
    SlickItem
  },
  data: function() {
    return {
      imgDomain: '',
      dailyOffer: {},
      sliderIsClickble: true,
      slickCompact: {
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        infinite: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getDailyOffer();
  },
  methods: {
    getDailyOffer() {
      this.$http.get(process.env.VUE_APP_API + 'items/daily')
      .then((res) => {
        this.dailyOffer = res.data.payload;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    goToProduct(item) {
      this.$parent.goToProduct(item);
    },
    goToSliderItem(item) {
      let self = this;
      setTimeout(()=> {
        if (self.sliderIsClickble == true) {
          console.log(3)
          self.$parent.goToProduct(item)
        }
      }, 200)
    },
    addToCart(item, id) {
      this.$parent.addToCart(item, id);
    },
    handleSwipe() {
      let self = this;
      self.sliderIsClickble = false;
      setTimeout(()=> {
        self.sliderIsClickble = true;
      }, 300)
    },
    handleInit(event, slick) {
        console.log('handleInit', event, slick);
    }
  }
}
</script>